<script lang="ts">
	import * as THREE from "three";
	import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
	import { onMount } from "svelte";

	let face : THREE.Mesh;
	let camera : THREE.Camera;
	let uvs : THREE.BufferAttribute;
	let colors : THREE.BufferAttribute;

	let isPointerDown = false;
	let previousX = 0;
	const targetVelocity = 0.002;
	const maxVelocity = 0.01;
	let velocity = targetVelocity;

	const scene = new THREE.Scene();
	const colorLookup = [
		new THREE.Color(0.167, 0.745427, 0.9),
		new THREE.Color(0, 0.133, 0.9),
		new THREE.Color(0, 0.348, 0.9),
		new THREE.Color(0.466401, 0, 0.9),
		new THREE.Color(1, 0.177, 1),
	];

	const renderer = new THREE.WebGLRenderer({ alpha: true });
	renderer.setSize(450, 400);
	renderer.setClearColor(0xffffff, 0);

	let lastTime = 0;
	function animate(now : number) {
		let deltaTime = now - lastTime;
		lastTime = now;
		requestAnimationFrame(animate);
		renderer.render(scene, camera);
		face.rotation.y += velocity * deltaTime;
		velocity = THREE.MathUtils.clamp(velocity, -maxVelocity, maxVelocity);
		velocity = THREE.MathUtils.lerp(velocity, targetVelocity, .02);
	}

	onMount(async () => {
		const loader = new GLTFLoader();
		loader.load(
			"models/scene.gltf",
			function (gltf) {
				scene.add(gltf.scene);
				face = scene.getObjectByName("face") as THREE.Mesh;
				camera = scene.getObjectByName("PerspectiveCamera") as THREE.Camera;
				animate(0);
				
				colors = face.geometry.attributes.color as THREE.BufferAttribute;
				uvs = face.geometry.attributes.uv as THREE.BufferAttribute;

				setInterval(() => {
					let random = Math.random();
					for (let i = 0; i < colors.count; i++) {
						let seed = (uvs.getX(i) + random) * 100000000;
						let index = Math.floor(THREE.MathUtils.seededRandom(seed) * colorLookup.length);
						let color = colorLookup[index];
						colors.setXYZ(i, color.r, color.g, color.b);
					}
					colors.needsUpdate = true;
				}, 150);
			},
			undefined,
			function (error) {
				console.error(error);
			}
		);
		document.getElementById("Face").appendChild(renderer.domElement);
	});

	renderer.domElement.onclick = (e) => {
		velocity += .03 * Math.sign(e.x - window.innerWidth * 0.5);
	};

	window.onpointerdown = (e : PointerEvent) => {
		isPointerDown = true;
		previousX = e.x;
	};

	window.onpointerup = (e : PointerEvent) => {
		isPointerDown = false;
	};

	window.onpointermove = (e : PointerEvent) => {
		if (isPointerDown)
		{
			let delta = e.movementX;
			let maxDelta = 3;
		 	delta = THREE.MathUtils.clamp(delta, -maxDelta, maxDelta);
			velocity += delta * 0.0002;
			previousX = e.x;
		}
	};

</script>

<div id="Face" />

<style>
	#Face {
		touch-action: none;
	}
</style>
